<template>
  <div class="app" :class="classes" @keydown.esc="close">
    <splash-screen v-if="!ready"></splash-screen>
    <layout v-else></layout>
    <modal></modal>
    <notification></notification>
    <context-menu></context-menu>
  </div>
</template>

<script>
import '../styles';
import '../styles/markdownHighlighting.scss';
import '../styles/app.scss';
import Layout from './Layout';
import Modal from './Modal';
import Notification from './Notification';
import ContextMenu from './ContextMenu';
import SplashScreen from './SplashScreen';
import syncSvc from '../services/syncSvc';
import networkSvc from '../services/networkSvc';
import tempFileSvc from '../services/tempFileSvc';
import store from '../store';
import shareSvc from '../services/shareSvc';
import workspaceSvc from '../services/workspaceSvc';
import Provider from '../services/providers/common/Provider';
import './common/vueGlobals';

const themeClasses = {
  light: ['app--light'],
  dark: ['app--dark'],
};

export default {
  components: {
    Layout,
    Modal,
    Notification,
    ContextMenu,
    SplashScreen,
  },
  data: () => ({
    ready: false,
  }),
  computed: {
    classes() {
      const result = themeClasses[store.getters['data/computedSettings'].colorTheme];
      return Array.isArray(result) ? result : themeClasses.light;
    },
  },
  methods: {
    close() {
      tempFileSvc.close();
    },
  },
  async created() {
    try {
      await syncSvc.init();
      await networkSvc.init();
      this.ready = true;
      tempFileSvc.setReady();

      // Import a shared document if the URL contains ?share=<id>
      const params = new URLSearchParams(window.location.search);
      const shareId = params.get('share');
      if (shareId) {
        window.history.replaceState(null, '', window.location.pathname);
        try {
          const { content, name } = await shareSvc.getShare(shareId);
          const existing = Object.values(store.state.file.itemsById)
            .find(f => f.name === name);
          if (existing) {
            try {
              await store.dispatch('modal/open', { type: 'shareConflict', name });
              // User chose "Overwrite"
              const existingContent = store.state.content.itemsById[`${existing.id}/content`];
              store.commit('content/setItem', {
                ...(existingContent || {}),
                id: `${existing.id}/content`,
                text: content,
              });
              store.commit('file/setCurrentId', existing.id);
            } catch (e) {
              // User chose "Create new file"
              const item = await workspaceSvc.createFile({
                ...Provider.parseContent(content),
                name,
              });
              store.commit('file/setCurrentId', item.id);
            }
          } else {
            const item = await workspaceSvc.createFile({
              ...Provider.parseContent(content),
              name,
            });
            store.commit('file/setCurrentId', item.id);
          }
        } catch (e) {
          store.dispatch('notification/error', 'Could not load shared document.');
        }
      }
    } catch (err) {
      if (err && err.message === 'RELOAD') {
        window.location.reload();
      } else if (err && err.message !== 'RELOAD') {
        console.error(err); // eslint-disable-line no-console
        store.dispatch('notification/error', err);
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/App.vue